import { render, staticRenderFns } from "./r-cell-key.vue?vue&type=template&id=2b7b0508"
import script from "./r-cell-key.vue?vue&type=script&lang=js"
export * from "./r-cell-key.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7b0508')) {
      api.createRecord('2b7b0508', component.options)
    } else {
      api.reload('2b7b0508', component.options)
    }
    module.hot.accept("./r-cell-key.vue?vue&type=template&id=2b7b0508", function () {
      api.rerender('2b7b0508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/cells/r-cell-key.vue"
export default component.exports